import { useContext } from 'react';
import { Modal, ModalProps } from '@material-ui/core';

import Context from './BoundModalContext';

const BoundModal: React.FC<ModalProps> = props => {
    const container = useContext(Context);

    return <Modal {...props} container={container} />;
};

export default BoundModal;
